import React from 'react';
export function FormatsSection() {
  return <section className="w-full py-20 bg-white" data-id="element-144">
      <div className="max-w-6xl mx-auto px-6" data-id="element-145">
        <div className="text-center mb-12" data-id="element-146">
          <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-147">
            📱 Acceso Digital Inmediato
          </h2>
          <p className="text-xl text-gray-600" data-id="element-148">
            Lee en cualquier dispositivo, en cualquier momento
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-149">
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-3xl p-12 text-center space-y-6" data-id="element-150">
            <div className="text-7xl mb-6" data-id="element-151">📱</div>
            <h3 className="text-3xl font-bold text-navy-900" data-id="element-152">Ebook Digital</h3>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-153">
              Recibe acceso inmediato después de tu compra. Lee en tu teléfono,
              tablet, computadora o cualquier dispositivo. Descarga los PDFs y
              tenlos para siempre.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mt-8" data-id="element-154">
              <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-155">
                <div className="text-3xl mb-3" data-id="element-156">⚡</div>
                <h4 className="font-bold text-navy-900 mb-2" data-id="element-157">
                  Acceso Instantáneo
                </h4>
                <p className="text-sm text-gray-600" data-id="element-158">
                  Empieza a leer en segundos
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-159">
                <div className="text-3xl mb-3" data-id="element-160">📲</div>
                <h4 className="font-bold text-navy-900 mb-2" data-id="element-161">
                  Multi-Dispositivo
                </h4>
                <p className="text-sm text-gray-600" data-id="element-162">
                  Lee donde quieras, cuando quieras
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-163">
                <div className="text-3xl mb-3" data-id="element-164">💾</div>
                <h4 className="font-bold text-navy-900 mb-2" data-id="element-165">
                  Tuyo Para Siempre
                </h4>
                <p className="text-sm text-gray-600" data-id="element-166">
                  Descarga y guarda los archivos
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-167">
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-168">
            Formato <strong className="text-magenta-600" data-id="element-169">PDF optimizado</strong>{' '}
            para lectura en cualquier dispositivo. Compatible con iPhone,
            Android, iPad, Kindle, computadoras y más.
          </p>
        </div>
      </div>
    </section>;
}